import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import SmartScreen from './components/SmartScreen';
import { CurrentScreenDataProvider } from '../../../contexts/CurrentScreenDataContext';

const SmartScreenPage = (props) => (
    <Container>
        <CurrentScreenDataProvider>
            <SmartScreen {...props} />
        </CurrentScreenDataProvider>
    </Container>
);

SmartScreenPage.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(SmartScreenPage);
